import React from 'react';
import AbstractComponent from '../../AbstractComponent';

class Footer extends AbstractComponent { 
    render() {        
        return (
            <footer className="py-4 bg-light mt-auto">
                <div className="container-fluid">
                    <div className="d-flex align-items-center justify-content-between small">
                        <div className="col-md-6                                 
                                        col-sm-6                                                
                                        col-lg-6                                                
                                        col-xs-6
                                        text-muted">
                            Copyright &copy; Avance Sistemas e Consultoria 2020
                        </div>

                        <div>
                            <a href="#">
                                Privacy Policy
                            </a>

                            &middot;
                            <a href="#">
                                Terms &amp; Conditions
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;